import * as React from "react";
import { styled } from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";
import MuiDrawer, { drawerClasses } from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import MenuContent from "./MenuContent";
import OptionsMenu from "./OptionsMenu";

const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
	width: drawerWidth,
	flexShrink: 0,
	boxSizing: "border-box",
	mt: 10,
	[`& .${drawerClasses.paper}`]: {
		width: drawerWidth,
		boxSizing: "border-box",
	},
});

export default function SideMenu({ token, isAuthenticated, setIsAuthenticated, username }) {
	return (
		<Drawer
			variant="permanent"
			sx={{
				display: { xs: "none", md: "block" },
				[`& .${drawerClasses.paper}`]: {
					backgroundColor: "background.paper",
				},
			}}
		>
			<Box
				component="img"
				sx={{
					height: 50,
					width: 200,
					maxHeight: { xs: 200, md: 200 },
					maxWidth: { xs: 200, md: 200 },
				}}
				alt="FlashTeller"
				src="/flashteller.png"
			></Box>
			<Divider />
			<Box
				sx={{
					overflow: "auto",
					height: "100%",
					display: "flex",
					flexDirection: "column",
				}}
			>
				<MenuContent token={token} />
			</Box>
			<Stack
				direction="row"
				sx={{
					p: 2,
					gap: 1,
					alignItems: "center",
					borderTop: "1px solid",
					borderColor: "divider",
				}}
			>
				<Avatar sizes="small" alt="Agent User" src="" sx={{ width: 36, height: 36 }} />
				<Box sx={{ mr: "auto" }}>
					<Typography variant="body2" sx={{ fontWeight: 500, lineHeight: "16px" }}>
						{username}
					</Typography>
				</Box>
				<OptionsMenu isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
			</Stack>
		</Drawer>
	);
}
